<template>
  <div>
    <section role="form">
      <div class="main-container container">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <h4>
                  Dados Pessoais
                  <span v-if="recadastramentos.length > 1"
                    >- {{ cadastro.registro | formataRegistro }}</span
                  >
                </h4>
                <div class="alert alert-warning" role="alert" style="margin-bottom: 15px; text-align: justify;">
                  <i class="fa fa-exclamation-triangle fa-lg"></i>&nbsp; <strong>Atenção:</strong> Para alterações de nome deve ser anexado o CPF atualizado da Receita Federal. Baixar no link: https://servicos.receita.fazenda.gov.br/servicos/cpf/consultasituacao/consultapublica.asp
                </div>
                <div class="row row-input">
                  <transition name="fade" mode="out-in">
                    <div
                      class="col-md-3 col-sm-3"
                      v-if="this.recadastramentos.length > 1"
                    >
                      <div class="form-group">
                        <select
                          class="form-control"
                          v-model="cadastro"
                          @change="trocaRegistro(cadastro.id)"
                        >
                          <option
                            v-for="recadastramento of recadastramentos"
                            :key="recadastramento.id"
                            :value="recadastramento"
                          >
                            {{
                              ('Registro ' + recadastramento.registro)
                                | formataRegistro
                            }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </transition>
                </div>
                <div class="row">
                  <table-loader :carregando="carregando">
                    <div class="row row-field" style="margin-bottom: 2rem">
                      <div class="form-row">
                        <div
                          class="form-group col-md-3 col-sm-6 paragrafosPertoDeInput"
                        >
                          <label for="nome">Nome</label>
                          <field-validation
                            :status="errors"
                            :custom-errors="apiErrors"
                            :show-icon="false"
                          >
                          <input
                            type="text"
                            name="nome"
                            id="nome"
                            class="form-control"
                            v-model="cadastrado.pessoa.nome"
                            v-sem-acentos
                            :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'"
                            maxlength="50"
                          />
                          </field-validation>
                        </div>
                        <div
                          class="form-group col-md-3 col-sm-6 paragrafosPertoDeInput"
                        >
                          <label for="cpf">CPF</label>
                          <p>{{ cadastrado.cpf | cpfMask }}</p>
                        </div>
                        <div
                          class="form-group col-md-3 col-sm-6 paragrafosPertoDeInput"
                        >
                        <field-validation
                        :status="errors"
                        label="Orientação Sexual"
                        :custom-errors="apiErrors"
                        :show-icon="false"
                        field="orientacaoSexual"
                        >
                        <select
                          v-model="cadastrado.pessoa.orientacaoSexual"
                          name="orientacaoSexual"
                          class="form-control"
                          v-validate="'required'"
                          data-vv-as="Orientação Sexual"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                        <option value :selected="true">Escolha</option>
                        <option
                          v-for="orientacaoSexual of orientacoesSexuais"
                          :key="orientacaoSexual.name"
                          :value="orientacaoSexual.name">
                          {{ orientacaoSexual.displayName | tudoMaiusculo }}
                        </option>
                        </select>
                        </field-validation>
                        </div>
                        <div
                          class="form-group col-md-3 col-sm-6 paragrafosPertoDeInput"
                        >
                          <field-validation
                          :status="errors"
                          label="Identidade de Gênero"
                          :custom-errors="apiErrors"
                          :show-icon="false"
                          field="genero"
                          >
                          <select
                            v-model="cadastrado.pessoa.genero"
                            name="genero"
                            class="form-control"
                            v-validate="'required'"
                            data-vv-as="Identidade de Gênero" 
                            :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'">
                            <option value :selected="true">Escolha</option>
                            <option
                              v-for="genero of generos"
                              :key="genero.name"
                              :value="genero.name">
                              {{ genero.displayName | tudoMaiusculo }}
                            </option>
                          </select>
                          </field-validation>
                        </div>
                      </div>
                    </div>
                    <!--espaço aqui-->
                    <div class="row row-field">
                      <div class="col-md-3 col-sm-3">
                        <!-- <campo-calendario rotulo="Data de Nascimento" nome="dataNascimento"
                          :data-maxima="dezoitoAnosAtras" :validacao="{ required: true }"
                          v-model="cadastrado.pessoa.dataNascimento" :disabled="cadastrado.lancamentoPermitido" /> -->
                        <div v-if="!cadastrado.lancamentoPermitido">
                          <campo-calendario
                            :disabled="situacaoRecad === 'CONFIRMADO'"
                            rotulo="Data de Nascimento"
                            nome="dataNascimento"
                            :data-maxima="dezoitoAnosAtras"
                            :validacao="{ required: true }"
                            v-model="cadastrado.pessoa.dataNascimento"
                          />
                        </div>
                        <div v-else>
                          <label for="dataEmissao">Data da Emissão</label>
                          <p
                            class="textoAlinhadoAoInput form-control"
                            style="background-color: #eeee; opacity: 1"
                          >
                            {{ formatarData(cadastrado.pessoa.dataNascimento) }}
                          </p>
                        </div>
                      </div>
                      <field-validation
                        css-class="col-md-3 col-sm-3"
                        label="Raça/Cor"
                        field="cor"
                        :status="errors"
                        :custom-errors="apiErrors"
                        :show-icon="false"
                      >                  
                      <select
                          class="form-control"
                          name="cor"
                          v-model="cadastrado.pessoa.racaCor"
                          v-validate="'required'"
                          data-vv-as="Raça/Cor"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'"
                        >
                          <option value :selected="true">Escolha</option>
                          <option
                            v-for="cor of cores"
                            :value="cor.name"
                            :key="cor.name"
                          >
                            {{ cor.displayName | tudoMaiusculo }}
                          </option>
                        </select>
                      </field-validation>
                      <field-validation
                        css-class="col-md-3 col-sm-3"
                        label="Estado Civil"
                        field="estadoCivil"
                        :status="errors"
                        :custom-errors="apiErrors"
                        :show-icon="false"
                      >
                        <select
                          class="form-control"
                          name="estadoCivil"
                          v-model="cadastrado.pessoa.estadoCivil"
                          v-validate="'required'"
                          data-vv-as="Estado Civil"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'"
                        >
                          <option value :selected="true">Escolha</option>
                          <option
                            v-for="estadoCivil of estadosCivis"
                            :value="estadoCivil.name"
                            :key="estadoCivil.name"
                          >
                            {{ estadoCivil.displayName | tudoMaiusculo }}
                          </option>
                        </select>
                      </field-validation>
                      <div class="form-group col-sm-3">
                        <label for="grauInstrucao">Grau de Escolaridade</label>
                        <p class="textoAlinhadoAoInput">
                          {{ grauInstrucaoDisplay }}
                        </p>
                      </div>
                    </div>

                    <div class="row row-field">
                      <field-validation
                        css-class="col-md-4 col-sm-4"
                        label="Município de Nascimento"
                        field="municipioNaturalidade"
                        v-sem-acentos
                        :status="errors"
                        :custom-errors="apiErrors"
                        :show-icon="false"
                      >
                        <input
                          type="text"
                          name="municipioNaturalidade"
                          id="municipioNaturalidade"
                          class="form-control"
                          v-model="cadastrado.pessoa.naturalidade.cidade"
                          v-validate="'required|max:40'"
                          data-vv-as="Município"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'"
                        />
                      </field-validation>
                      <field-validation
                        css-class="col-md-4 col-sm-4"
                        label="Estado de Nascimento"
                        field="ufNaturalidade"
                        :status="errors"
                        :custom-errors="apiErrors"
                        :show-icon="false"
                      >
                        <select
                          class="form-control"
                          name="ufNaturalidade"
                          v-model="cadastrado.pessoa.naturalidade.uf"
                          v-validate="{ required: ehBrasil }"
                          data-vv-as="Estado"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'"
                        >
                          <option value :selected="true">Escolha</option>
                          <option
                            v-for="uf of ufs"
                            :value="uf.sigla"
                            :key="uf.id"
                          >
                            {{ uf.nome | tudoMaiusculo }}
                          </option>
                        </select>
                      </field-validation>
                      <field-validation
                        css-class="col-md-4 col-sm-4"
                        label="Nacionalidade"
                        field="nacionalidade"
                        :status="errors"
                        :custom-errors="apiErrors"
                        :show-icon="false"
                      >
                        <select
                          class="form-control"
                          name="nacionalidade"
                          v-model="cadastrado.pessoa.naturalidade.pais"
                          v-validate="'required'"
                          data-vv-as="Nacionalidade"
                          :disabled="cadastrado.lancamentoPermitido || situacaoRecad === 'CONFIRMADO'"
                        >
                          <option value :selected="true">Escolha</option>
                          <option
                            v-for="pais of paises"
                            :value="pais"
                            :key="pais"
                          >
                            {{ pais }}
                          </option>
                        </select>
                      </field-validation>
                    </div>
                  </table-loader>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="controller">
      <div class="container footer-controller">
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <botao
              estilo="cheio-cinza-esq"
              rotulo="Desfazer"
              icone="fa-undo"
              @clicado="recarregaDados()"
              v-tooltip.right="'Desfaz alterações de todas as etapas'"
            />
            <botao
              estilo="cheio-verde-dir"
              rotulo="Avançar"
              icone="avancar"
              :icone-direita="true"
              @clicado="avanca(recadastramentos, ufs, cadastrado, 'Endereco')"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Botao from '@/components/botao';
import CampoCalendario from '@/components/campo-calendario';
import TableLoader from '@/components/table-loader';
import axios from 'axios';
import moment from 'moment';
import Hash from 'object-hash';
import Cadastrado from '@/domain/cadastrado';
import DateHelper from '@/helpers/DateHelper';
import ErrorHelper from '@/helpers/ErrorHelper';
import StringHelper from '@/helpers/StringHelper';
import RecadastramentoService from '@/services/recadastramentoService';
import PaisesService from '@/services/enums/paisesService';
import EstadosCivisService from '@/services/enums/estadosCivisService';
import GrausInstrucoesService from '@/services/enums/grausInstrucoesService';
import RacasCoresService from '@/services/enums/racasCoresService';
import EnderecoService from '@/services/enderecoService';
import { getEstados } from '@/services/estadoService';
import OrientacaoSexualService from '@/services/enums/orientacaoSexualService';
import IdentidadeGeneroService from '@/services/enums/identidadeGeneroService';

export default {
  name: 'DadosPessoais',

  data() {
    return {
      carregando: true,
      recadastramentos: [],
      recadMesCompetencia: [],
      // cadastro: {},
      cadastrado: {
        pessoa: {
          genero: '',
          orientacaoSexual: '',
          naturalidade: {
            cidade: '',
            uf: '',
            pais: '',
          },
          dataNascimento: '',
          nome: '',
        },
      },
      ufs: [],
      paises: [],
      cores: [],
      estadosCivis: [],
      grausInstrucoes: [],
      orientacoesSexuais: [],
      generos: [],
      apiErrors: null,
    };
  },
  computed: {
    situacaoRecad() {
      return this.$store.getters.getSituacaoRecad;
    },
    ehBrasil() {
      return this.cadastrado.pessoa.naturalidade.pais === 'BRASIL'
        ? true
        : false;
    },
    grauInstrucaoDisplay() {
      const graus = this.grausInstrucoes.filter(
        item => item.name === this.cadastrado.pessoa.grauInstrucao,
      );
      const grau = filterResult =>
        filterResult.length ? filterResult[0].displayName.toUpperCase() : '';
      return grau(graus);
    },
    dezoitoAnosAtras() {
      return moment(new Date()).add(-18, 'years').format('YYYY-MM-DD');
    },
  },
  methods: {
    avanca(recadastramentos, ufs, cadastrado, proximoLink) {
      // limpeza de espaços em branco
      let grupoEndereco = cadastrado.pessoa.endereco;
      Object.keys(grupoEndereco).map(function (key, index) {
        if (typeof grupoEndereco[key] === 'string') {
          grupoEndereco[key] = grupoEndereco[key].trim();
        }
      });
      this.$validator.validateAll().then(success => {
        let { dataNascimento, naturalidade } = cadastrado.pessoa;

        if (success) {
          if (dataNascimento) {
            cadastrado.pessoa.dataNascimento =
              DateHelper.convertPtbrToApiDate(dataNascimento);
            const multiplosRegistros =
              recadastramentos.length > 1 ? true : false;
            cadastrado.mostraMultiplosRegistros = multiplosRegistros;

            this.tiraAcentuacao(naturalidade);
            this.setAnexos(cadastrado, this.$store.state.cadastroModelo);
            this.$store.commit('setEstados', ufs);
            this.$store.commit('setFuncionarioCadastrado', cadastrado);
            this.$router.push({ name: proximoLink });
            return;
          }
          this.$root.$refs.toastr.e('Preencha a Data de Nascimento', 'Atenção');
          return;
        }
        this.$root.$refs.toastr.e('Corrija os campos em vermelho', 'Atenção');
      });
    },
    tiraAcentuacao(naturalidade) {
      if (StringHelper.verificaCaracterEspecial(naturalidade.cidade)) {
        naturalidade.cidade = StringHelper.limpaCaracterEspecial(
          naturalidade.cidade,
        );
        this.$root.$refs.toastr.w(
          'A Atualização Cadastral não aceita acentos e cedilhas. A aplicação já fez as correções necessárias.',
          'Atenção',
        );
      }
    },
    setAnexos(cadastrado, original) {
      if (!cadastrado.documentosExigidos) cadastrado.documentosExigidos = [];
      if (!original || !original.pessoa) {
        // Evita erro se original ou original.pessoa não existir
        return;
      }
      const nomeOriginal = (original.pessoa.nome || '').trim().toUpperCase();
      const nomeAtual = (cadastrado.pessoa.nome || '').trim().toUpperCase();
      const nome = nomeAtual !== nomeOriginal;
      
      const dataNascimento =
        Hash(cadastrado.pessoa.dataNascimento) !=
        Hash(original.pessoa.dataNascimento)
          ? true
          : false;
      const estadoCivil =
        Hash(cadastrado.pessoa.estadoCivil) != Hash(original.pessoa.estadoCivil)
          ? true
          : false;
      const naturalidade =
        Hash(cadastrado.pessoa.naturalidade) !=
        Hash(original.pessoa.naturalidade)
          ? true
          : false;
      let documentos = [];

      if (dataNascimento || naturalidade)
        documentos.push('RG ou Certidão de Nascimento ou Decisão Judicial');
      if (estadoCivil)
        documentos.push('Certidão de Casamento (a mais recente)');

      if (cadastrado.documentosExigidos) {
        const novosDocumentos = documentos.filter(
          item => !cadastrado.documentosExigidos.includes(item),
        );
        cadastrado.documentosExigidos = [
          ...cadastrado.documentosExigidos,
          ...novosDocumentos,
        ];
      } else {
        cadastrado.documentosExigidos = [...documentos];
      }
    },
    recarregaDados() {
      const vazio = {};
      this.$store.commit('setCadastroModelo', vazio);
      this.listaRecadastramentos();
      this.errors.clear();
    },
    estahVazio(objeto) {
      for (let key in objeto) {
        if (objeto.hasOwnProperty(key)) return false;
      }
      return true;
    },
    clonaESalvaModelo(cadastrado) {
      const cloneCadastrado = JSON.parse(JSON.stringify(cadastrado));
      this.$store.commit('setCadastroModelo', cloneCadastrado);
    },
    async obtemEstados() {
      try {
        const estadosData = getEstados();
        this.ufs = estadosData.map(estado => ({
          id: estado.id,
          nome: estado.nome,
          sigla: this.getSiglaFromNome(estado.nome)
        }));
      } catch (error) {
        console.error('Erro ao carregar estados:', error);
        this.emiteAlerta("Erro ao carregar estados");
      }
    },
    getSiglaFromNome(nome) {
      const siglas = {
        'Acre': 'AC',
        'Alagoas': 'AL',
        'Amapá': 'AP',
        'Amazonas': 'AM',
        'Bahia': 'BA',
        'Ceará': 'CE',
        'Distrito Federal': 'DF',
        'Espírito Santo': 'ES',
        'Goiás': 'GO',
        'Maranhão': 'MA',
        'Mato Grosso': 'MT',
        'Mato Grosso do Sul': 'MS',
        'Minas Gerais': 'MG',
        'Pará': 'PA',
        'Paraíba': 'PB',
        'Paraná': 'PR',
        'Pernambuco': 'PE',
        'Piauí': 'PI',
        'Rio de Janeiro': 'RJ',
        'Rio Grande do Norte': 'RN',
        'Rio Grande do Sul': 'RS',
        'Rondônia': 'RO',
        'Roraima': 'RR',
        'Santa Catarina': 'SC',
        'São Paulo': 'SP',
        'Sergipe': 'SE',
        'Tocantins': 'TO'
      };
      return siglas[nome] || '';
    },
    async listaRecadastramentos() {
      try {
        const routeId = this.$route.params.id;
        const userId = routeId || sessionStorage.getItem('userId');
         
        //const response = await RecadastramentoService.lista();

        const response = await RecadastramentoService.obtemPorId(userId);
        
        this.cadastrado = await response;
        if (this.cadastrado != null || this.cadastrado != undefined) {
         //if (this.recadastramentos && this.recadastramentos.length > 0) {
        //   this.cadastrado = this.recadastramentos.find(
        //     item => item.id == userId,
        //   );
          
        //   console.log("Cadastrado: " + this.cadastrado.toString());
        //   if (!this.cadastrado) {
        //     this.cadastrado = this.recadastramentos[0];
        //   }

          this.clonaESalvaModelo(this.cadastrado);
          this.$store.commit('setFuncionarioCadastrado', this.cadastrado);
        }

        this.carregando = false;
      } catch (error) {
        this.carregando = false;
        const msg =
          error.body && error.body.message
            ? error.body.message
            : error.message || 'Erro desconhecido';
        this.$root.$refs.toastr.e(msg, 'Atenção');
      }
    },
    async trocaRegistro(id) {
      const cadastradoSelecionado = this.recadastramentos.find(
        item => item.id == id,
      );

      if (!cadastradoSelecionado) {
        this.$root.$refs.toastr.e('Registro não encontrado', 'Atenção');
        return;
      }

      this.cadastrado = cadastradoSelecionado;
      this.clonaESalvaModelo(this.cadastrado);
    },
    async listaOrientacaoSexual() {
      try {
        const response = await OrientacaoSexualService.lista();
       // this.orientacoesSexuais = await response;
        let arrayResponse = await response;
        this.orientacoesSexuais = arrayResponse.map(item => ({
          name: item.name.replace(/_/g, " "),
          displayName: item.displayName,
        }));

      } catch (error) {
        this.$root.$refs.toastr.e(error.body.message, 'Atenção');
        this.orientacoesSexuais = [];
      }
    },
    async listaGenero() {
      try {
        const response = await IdentidadeGeneroService.lista();
          //this.generos = await response;
          let arrayResponse = await response;
          this.generos = arrayResponse.map(item => ({
            name: item.name.replace(/_/g, " "),
            displayName: item.displayName,
          }));
          
      } catch (error) {
         this.generos = [];
        this.$root.$refs.toastr.e(error.body.message, 'Atenção');
      }
    },
    async listaPaises() {
      try {
        const response = await PaisesService.lista();
        this.paises = await response;
      } catch (error) {
        this.$root.$refs.toastr.e(error.body.message, 'Atenção');
      }
    },
    async listaEstadosCivis() {
      try {
        const response = await EstadosCivisService.lista();
        const todosEstadosCivis = await response;
        this.estadosCivis = todosEstadosCivis.filter(
          item => item.name !== 'NAO_INFORMADO',
        );
      } catch (error) {
        this.$root.$refs.toastr.e(error.body.message, 'Atenção');
      }
    },
    async listaGrausInstrucoes() {
      try {
        const response = await GrausInstrucoesService.lista();
        this.grausInstrucoes = await response;
      } catch (error) {
        this.$root.$refs.toastr.e(error.body.message, 'Atenção');
      }
    },
    async listaRacasCores() {
      try {
        const response = await RacasCoresService.lista();
        this.cores = await response;
      } catch (error) {
        this.$root.$refs.toastr.e(error.body.message, 'Atenção');
      }
    },
    carregaDadosIniciais() {
      try {
        this.listaRecadastramentos();
        this.listaGenero();
        this.listaOrientacaoSexual();
        this.obtemEstados();
        
      if (typeof this.obtemMunicipiosPor === 'function' && this.parentEstado) {
        this.obtemMunicipiosPor(this.parentEstado);
      }
      
      if (typeof this.obtemTiposLogradouros === 'function') {
        this.obtemTiposLogradouros();
      }
      
      if (typeof this.cepMasked === 'function' && this.parentCep) {
        this.enderecoEditado.cep = this.cepMasked(this.parentCep);
      } else if (this.parentCep) {
        this.enderecoEditado.cep = this.formatarCep(this.parentCep);
      }
      
      this.enderecoEditado.tipoLogradouro = this.parentTipoLogradouro || '';
      
      if (this.parentLogradouro) {
        this.enderecoEditado.logradouro = this.parentLogradouro.toUpperCase();
      }
      
      if (this.parentBairro) {
        this.enderecoEditado.bairro = this.parentBairro.toUpperCase();
      }
      
      this.enderecoEditado.municipio = this.parentMunicipio || '';
      this.enderecoEditado.estado = this.parentEstado || '';
      this.enderecoEditado.numero = this.parentNumero || '';
      
      if (this.parentComplemento) {
        this.enderecoEditado.complemento = this.parentComplemento.toUpperCase();
      }
      
      this.enderecoEditado.georreferenciado = this.parentGeorreferenciado || false;
      this.enderecoEditado.inseridoPeloUsuario = this.parentInseridoPeloUsuario || false;
    } catch (error) {
      console.error('Erro ao carregar dados iniciais:', error);
    }
  },
    formatarData(data) {
      if (!data) return '';
      const dataObj = new Date(data);
      return dataObj.toLocaleDateString('pt-BR');
    },
  },
  created() {
    this.listaPaises();
    this.listaEstadosCivis();
    this.listaGrausInstrucoes();
    this.listaRacasCores();
    this.obtemEstados();
    this.carregaDadosIniciais();
     
    this.$eventBus.$on('salvaAvanca', nomeComponente => {
      this.avanca(
        this.recadastramentos,
        this.ufs,
        this.cadastrado,
        nomeComponente,
      );
    });
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  beforeDestroy() {
    this.$eventBus.$off('salvaAvanca');
  },
  components: {
    Botao,
    CampoCalendario,
    TableLoader,
  },
};
</script>

<style scoped>
.card {
  overflow: visible;
}

.paragrafosPertoDeInput {
  margin-bottom: 0;
  /* Remove margens desnecessárias */
}

.select-disabled {
  background-color: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// index.vue?355be386